import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
} from "@@/shared/date-time/iso-and-unix";

import type { Price} from "@@/shared/prices/price";
import { priceZodSchema } from "@@/shared/prices/price";
import { z } from "zod";

const notificationProvidersForSms = ["postmark"] as const;
type NotificationProviderForSms = (typeof notificationProvidersForSms)[number];
const notificationProviderForSmsZodSchema: z.ZodSchema<NotificationProviderForSms> =
    z.enum(notificationProvidersForSms);

type NotificationStatsForSms = {
    start: IsoAndUnixTimestamp;
    end: IsoAndUnixTimestamp;
    notificationProvider: NotificationProviderForSms;
    sent: number;
    smsParts: number;
    cost: Price;
};

const notificationStatsForSmsZodSchema = z
    .object({
        start: isoAndUnixZodSchema,
        end: isoAndUnixZodSchema,
        notificationProvider: notificationProviderForSmsZodSchema,
        sent: z.number().min(0),
        smsParts: z.number().min(0),
        cost: priceZodSchema,
    })
    .refine(stats => stats.smsParts >= stats.sent, {
        message:
            "number of sms parts must be greater than or equal to number of sent sms messages",
    });

export {
    notificationProviderForSmsZodSchema,
    notificationProvidersForSms,
    notificationStatsForSmsZodSchema,
};
export type { NotificationProviderForSms, NotificationStatsForSms };
